import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { FileText, Download, Clock } from "lucide-react";
import "./VendorDocuments.css";

const VendorDocuments = () => {
  const { vendor } = useOutletContext();
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!vendor?.id) { setLoading(false); return; }

    const load = async () => {
      const { data, error } = await supabase
        .from("vendor_applications")
        .select("id, indemnity_path, indemnity_name, agreement_path, agreement_name, events ( name, event_key )")
        .eq("vendor_id", vendor.id)
        .order("created_at", { ascending: false });

      if (error) console.error("Documents:", error);
      setRows(data || []);
      setLoading(false);
    };

    load();
  }, [vendor?.id]);

  if (loading) return <div className="vdoc-loading">Loading documents…</div>;

  const docRows = rows.flatMap((app) => {
    const items = [];
    if (app.indemnity_path) items.push({ key: `${app.id}-indemnity`, event: app.events?.name, name: app.indemnity_name || "Indemnity form", path: app.indemnity_path });
    if (app.agreement_path) items.push({ key: `${app.id}-agreement`, event: app.events?.name, name: app.agreement_name || "Agreement", path: app.agreement_path });
    return items;
  });

  return (
    <div className="vdoc-page">
      <div className="vdoc-header">
        <h1 className="vdoc-title">Documents</h1>
        <p className="vdoc-subtitle">Everything you've signed or uploaded, across every event.</p>
      </div>

      {docRows.length === 0 ? (
        <div className="vdoc-empty">
          <Clock size={20} />
          <p>No documents yet. Once you're accepted into an event, signed forms will show up here.</p>
        </div>
      ) : (
        <div className="vdoc-list">
          {docRows.map((doc) => (
            <div key={doc.key} className="vdoc-row">
              <div className="vdoc-row-left">
                <FileText size={16} />
                <div>
                  <span className="vdoc-name">{doc.name}</span>
                  <span className="vdoc-event">{doc.event || "Event"}</span>
                </div>
              </div>
              <a href={doc.path} target="_blank" rel="noreferrer" className="vdoc-download">
                <Download size={14} /> View
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VendorDocuments;